import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NavListService {
  constructor() { }
  action$ = new Subject<any>();

}
